import * as Sentry from '@sentry/vue'
import router from '@/router'

export default {
  install(app: any) {
    if (!import.meta.env.VITE_APP_SENTRY_DSN) {
      return
    }
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_DSN,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      tracePropagationTargets: ['localhost', /^\//],
      ignoreErrors: [
        'Load failed',
        'Unable to preload',
        'Object captured as promise rejection with keys',
        'Expected mapDiv of type HTMLElement but was passed null',
      ],
    })
  },
}
